const axios = require('axios');

export function getAccessToken(order) {

  let data = {
    gatewayUsername:process.env.PS_GW_USERNAME,
    gatewayPassword: process.env.PS_GW_PWD,
    currencyCode: "826",
    amount: order.totalPrice.toString(),
    transactionType:"SALE",
    orderId:order.id.toString(),
  }
  return new Promise(function(resolve, reject) {
    let headers = {
      "Accept": "application/json",
      "Content-Type": "application/json",
      "Authorization": process.env.PAYMENTSENSE_JWT
    };
    console.log("get Access Token");
    console.log(data);
    console.log(headers);
    axios.post('https://e.test.connect.paymentsense.cloud/v1/access-tokens', JSON.stringify(data), {
      headers: headers
    }).then(function(response) {
      console.log("updateMenu Response");
      console.log(response);
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      console.log("updateMenuItem error " + err);
      console.log(err);
      if(err.response != undefined) {
        console.log(err.response);
      }
      reject(err);
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/paymentsense.js